module.exports = __webpack_public_path__ + "img/yleisöwc_original.f311fd5d.jpg";